import { RolesEnum } from '~/utils/roles';
import { User as AuthUser } from '~/contexts/AuthContext/types';

type User = {
  accessType: string;
  funcao?: string;
};

type ValidateUserPermissionsParams = {
  user?: User;
  accessTypes?: string[];
};

type ValidateUserRoleParams = {
  user?: User;
  roles?: string[];
};

export function validateUserPermissions({
  user,
  accessTypes = [],
}: ValidateUserPermissionsParams): boolean {
  if (accessTypes.length > 0) {
    const hasAllAccessTypes = accessTypes.some(accessType => {
      return user?.accessType.includes(accessType);
    });

    if (!hasAllAccessTypes) return false;
  }

  return true;
}

export function validateUserRole({
  user,
  roles = [],
}: ValidateUserRoleParams): boolean {
  if (roles.length > 0) {
    const hasRole = roles.some(role => {
      return user?.funcao?.toLocaleLowerCase() === role.toLocaleLowerCase();
    });

    if (!hasRole) return false;
  }

  return true;
}

export function userCanSeeBusinessInfo(
  user: AuthUser,
  roles?: RolesEnum[],
): boolean {
  if (user.accessType === 'ADMIN') return true;

  const keys = Object.keys(RolesEnum) as (keyof typeof RolesEnum)[];
  const foundKey = keys.find(
    key => RolesEnum[key] === user.funcao.toLocaleLowerCase(),
  );
  if (!foundKey) {
    // nao encontrou a funcao do usuario
    console.log('funcao nao encontrada', user.funcao.toLocaleLowerCase());
    return false;
  }
  // usuario nao possui as funcoes necessarias
  if (roles?.length && !roles.includes(RolesEnum[foundKey])) return false;

  // checar se usuario possui as permissoes necessarias
  if (RolesEnum[foundKey] === RolesEnum.PARCEIRO_COMERCIAL) return true;

  return (
    RolesEnum[foundKey] === RolesEnum.GERENTE_CONTAS &&
    (user?.comissionado || user?.visualizar_comissao)
  );
}
